import { memo, useCallback } from "react";

import { useProduct } from "@shopify/hydrogen-react";

import { type OPProductVariantConnection } from "@root/tablescape/state";
import {
  formatProduct,
  formatProductVariant,
  updateUrlVariantId,
} from "@root/tablescape/utilities";

import { ProductFormView } from "./ProductForm.view";

type Props = {
  formatBtnText: {
    available: string;
    soldOut: string;
    waitlisted: string;
  };
};

const ProductFormBase = ({ formatBtnText }: Props) => {
  const { product, selectedVariant, setSelectedVariant } = useProduct();

  const setMatchedVariant = useCallback(
    (variantId: OPProductVariantConnection["id"]) => {
      const matchedVariant = product.variants.nodes.find((variant) => {
        return variant.id === variantId;
      });
      if (matchedVariant) {
        setSelectedVariant(matchedVariant);
        updateUrlVariantId(matchedVariant.id);
      }
    },
    [setSelectedVariant, product.variants.nodes]
  );

  return (
    <ProductFormView
      formatBtnText={formatBtnText}
      product={formatProduct(product)}
      selectedVariant={formatProductVariant(selectedVariant)}
      setSelectedVariant={setMatchedVariant}
    />
  );
};

export const ProductForm = memo(ProductFormBase);
